import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.4 15.5778L6.2432 13.2141C5.8688 13.141 5.6 12.8221 5.6 12.4511V11.5489C5.6 11.1779 5.8688 10.859 6.2432 10.7859L18.4 8.42223V15.5778ZM10.4 16.1704C10.4 16.6628 9.9352 17.0314 9.4384 16.9319L7.8384 16.6122C7.4672 16.5376 7.2 16.2194 7.2 15.85V14.9556L10.4 15.5778V16.1704ZM18.4 5.77778V6.86667L5.2864 9.41622C4.5384 9.56167 4 10.2002 4 10.9422V13.0578C4 13.7998 4.5384 14.4383 5.2864 14.5838L5.6 14.6444V16.452C5.6 17.1901 6.1336 17.8263 6.8776 17.9757L10.0776 18.6158C11.0704 18.8141 12 18.0768 12 17.0921V15.8889L18.4 17.1333V18.2222C18.4 18.6516 18.7584 19 19.2 19C19.6416 19 20 18.6516 20 18.2222V5.77778C20 5.34844 19.6416 5 19.2 5C18.7584 5 18.4 5.34844 18.4 5.77778Z'
        fill={fillColor}
      />
    </svg>
  );
});

export default React.memo(Icon);
